export default __webpack_public_path__ + "static/media/best-med-img.4c15c6f0.png";